import { Component, input, output } from '@angular/core';
import { RidButton } from '../rid-button/rid-button';

@Component({
  selector: 'rid-bottom-button',
  imports: [RidButton],
  templateUrl: './rid-bottom-button.html',
  host: {
    class: 'block absolute bottom-8',
    'animate.enter': 'anim-slide-from-bottom',
    'animate.leave': 'anim-slide-to-bottom',
  },
})
export class RidBottomButton {
  content = input.required<string>();
  disabled = input<boolean>(false);
  keybind = input<string>();

  clicked = output<void>();
}
